/*
 * @Description: 轨迹分段 / 时间窗口 / 快照 — 纯计算工具
 */
import { TrackPoint, parseLngLat } from '../types/cockpit.types'

/** 经纬度二元组 [lng, lat]（高德 Polyline path 用） */
export type LngLatTuple = [number, number]

/** 轨迹分段（轨迹页不再切中断段，gap 恒为 false、整段实线） */
export interface TrackSegment {
  /** 是否中断段（保留字段；当前恒 false） */
  gap: boolean
  path: LngLatTuple[]
}

/**
 * 取时间窗口 [startMs, endMs] 内的轨迹点（含端点）。
 *
 * @param points - 按时间升序的轨迹点
 */
export function filterPointsInWindow(
  points: TrackPoint[],
  startMs: number,
  endMs: number
): TrackPoint[] {
  return points.filter((p) => p.locateTime >= startMs && p.locateTime <= endMs)
}

/**
 * 把轨迹点连成一条实线段（不判断时间间隔、不切中断段，全部实线）。
 *
 * @param points - 按时间升序的轨迹点
 * @returns 单段实线（点数 < 2 时返回空）
 */
export function buildTrackSegments(points: TrackPoint[]): TrackSegment[] {
  const path: LngLatTuple[] = []
  for (let i = 0; i < points.length; i++) {
    const ll = parseLngLat(points[i].location)
    if (ll) path.push([ll.lng, ll.lat])
  }
  return path.length >= 2 ? [{ gap: false, path }] : []
}

/**
 * 取某时刻 T 的快照点：时间 ≤ T 的最后一个点（成员在 T 时刻所处位置）。
 *
 * @param points - 按时间升序的轨迹点
 * @param t - 目标时刻（unix 毫秒）
 * @returns 命中的点；T 之前无点则返回 null
 */
export function getNearestPointAt(
  points: TrackPoint[],
  t: number
): TrackPoint | null {
  let result: TrackPoint | null = null
  for (let i = 0; i < points.length; i++) {
    if (points[i].locateTime <= t) {
      result = points[i]
    } else {
      break
    }
  }
  return result
}
